(() => {
  'use strict';

  const ROOT = '[data-sovah-ingredients]';
  const STYLE_ID = 'sovah-ingredients-responsive-fix';
  const LABELS = new Set(['ingredients', 'key ingredient', 'key ingredients']);
  let lastTrigger = null;
  let timer = null;

  const injectStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      html.sovah-ingredients-lock,html.sovah-ingredients-lock body{overflow:hidden!important;overscroll-behavior:none}
      .sovah-ingredients-shell{display:block!important;width:min(calc(100% - 2rem),1280px)!important;max-width:1280px!important;margin-inline:auto!important;box-sizing:border-box!important}
      .sovah-ingredients-shell[hidden]{display:none!important}
      .sovah-ingredients{margin-block:clamp(2rem,4vw,3.5rem)!important;padding:clamp(1.35rem,2.8vw,2.1rem)!important;border-radius:1rem!important;background:linear-gradient(135deg,#333333 0%,#292d2c 72%,#24302f 100%)!important;box-shadow:none!important}
      .sovah-ingredients__heading-row{grid-template-columns:minmax(0,.9fr) minmax(18rem,.8fr)!important;align-items:end!important;gap:clamp(1.25rem,4vw,4rem)!important;margin-bottom:1.5rem!important}
      .sovah-ingredients__eyebrow,.sovah-ingredients-dialog__eyebrow,.sovah-ingredients-panel__label{color:#6ca6a3!important;font-size:.68rem!important;font-weight:650!important;letter-spacing:.16em!important}
      .sovah-ingredients__title{font-size:clamp(2rem,3vw,3rem)!important;line-height:1.05!important;letter-spacing:-.025em!important;font-weight:650!important}
      .sovah-ingredients__intro{max-width:31rem!important;color:rgba(255,255,255,.68)!important;font-size:.92rem!important;line-height:1.65!important}
      .sovah-ingredients__grid{grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:.9rem!important}
      .sovah-ingredient-card{min-width:0!important;min-height:11.5rem!important;border-radius:.75rem!important;border-color:rgba(255,255,255,.11)!important;box-shadow:inset 0 -58px 72px rgba(0,0,0,.32)!important}
      .sovah-ingredient-card__content{padding:1rem!important}
      .sovah-ingredient-card__name{font-size:clamp(1rem,1.2vw,1.18rem)!important;line-height:1.2!important;font-weight:650!important;letter-spacing:-.015em!important;overflow-wrap:anywhere}
      .sovah-ingredient-card__benefit{font-size:.79rem!important;line-height:1.5!important;color:rgba(255,255,255,.72)!important}
      .sovah-ingredients__open{position:relative!important;z-index:20!important;min-height:3rem!important;margin-top:1.15rem!important;padding:.78rem 1.05rem!important;border:1px solid #368582!important;border-radius:.65rem!important;background:#368582!important;color:#fff!important;font-size:.82rem!important;font-weight:650!important;letter-spacing:.025em!important;box-shadow:none!important;pointer-events:auto!important;touch-action:manipulation!important;-webkit-tap-highlight-color:transparent;cursor:pointer!important}
      .sovah-ingredients__open:hover{background:#2f7471!important;border-color:#2f7471!important;transform:none!important}
      .sovah-ingredients__open svg{width:1rem!important;height:1rem!important}
      .sovah-ingredients-dialog{position:fixed!important;z-index:2147483000!important;inset:0!important;width:min(62rem,calc(100% - 2rem))!important;max-width:none!important;max-height:min(54rem,calc(100dvh - 2rem))!important;margin:auto!important;border-radius:1rem!important;background:#2f3231!important}
      .sovah-ingredients-dialog:not([open]):not(.is-open){display:none!important}
      .sovah-ingredients-dialog[open],.sovah-ingredients-dialog.is-open{display:block!important}
      .sovah-ingredients-dialog__frame{max-height:min(54rem,calc(100dvh - 2rem))!important;overflow:auto!important;overscroll-behavior:contain;-webkit-overflow-scrolling:touch}
      .sovah-ingredients-dialog__header h2{font-size:clamp(1.8rem,3vw,2.65rem)!important;font-weight:650!important;letter-spacing:-.025em!important}
      .sovah-ingredients-dialog__header>p:last-child{color:rgba(255,255,255,.64)!important;font-size:.9rem!important}
      .sovah-ingredients-dialog__close{width:2.6rem!important;height:2.6rem!important;border-radius:.65rem!important;background:#3a3e3d!important;touch-action:manipulation!important}
      .sovah-ingredients-tabs{gap:.45rem!important}
      .sovah-ingredients-tabs__button{padding:.68rem .9rem!important;border-radius:.55rem!important;background:#343837!important;color:rgba(255,255,255,.68)!important;font-size:.78rem!important;font-weight:600!important;touch-action:manipulation!important}
      .sovah-ingredients-tabs__button[aria-selected="true"]{background:#368582!important;border-color:#368582!important;color:#fff!important}
      .sovah-ingredients-panel{border-radius:.75rem!important;background:#353938!important}
      .sovah-ingredients-panel__highlight{border-radius:.55rem!important;background:rgba(255,255,255,.025)!important}
      @media(min-width:750px) and (max-width:989px){
        .sovah-ingredients__heading-row{grid-template-columns:1fr!important;gap:.65rem!important}
        .sovah-ingredients__grid{grid-template-columns:repeat(2,minmax(0,1fr))!important}
        .sovah-ingredient-card{min-height:11rem!important}
      }
      @media(max-width:749px){
        .sovah-ingredients-shell{width:min(calc(100% - 1rem),100%)!important}
        .sovah-ingredients{margin-block:1.5rem 2.5rem!important;padding:1rem!important;border-radius:.85rem!important}
        .sovah-ingredients__heading-row,.sovah-ingredients__grid{grid-template-columns:1fr!important}
        .sovah-ingredients__heading-row{gap:.55rem!important;margin-bottom:1rem!important}
        .sovah-ingredients__title{font-size:2rem!important}
        .sovah-ingredients__intro{font-size:.86rem!important}
        .sovah-ingredient-card{min-height:10.5rem!important}
        .sovah-ingredients__open{width:100%!important;min-height:3.25rem!important}
        .sovah-ingredients-dialog{inset:auto 0 0!important;width:100%!important;max-height:calc(100dvh - .5rem)!important;margin:0!important;border-radius:1rem 1rem 0 0!important}
        .sovah-ingredients-dialog__frame{max-height:calc(100dvh - .5rem)!important;padding:1rem!important}
      }
    `;
    document.head.appendChild(style);
  };

  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const applyBrandCopy = (root) => {
    const hasRoutine = Boolean(root.querySelector('[data-sovah-ingredients-tabs]'));
    const eyebrow = root.querySelector('.sovah-ingredients__eyebrow');
    const title = root.querySelector('.sovah-ingredients__title');
    const intro = root.querySelector('.sovah-ingredients__intro');
    const openLabel = root.querySelector('[data-sovah-ingredients-open] span');
    const dialogEyebrow = root.querySelector('.sovah-ingredients-dialog__eyebrow');
    const dialogTitle = root.querySelector('.sovah-ingredients-dialog__header h2');
    const dialogIntro = root.querySelector('.sovah-ingredients-dialog__header > p:last-child');

    if (eyebrow) eyebrow.textContent = 'PURE CARE. CLEAR FORMULAS.';
    if (title) title.textContent = hasRoutine ? 'Inside your routine' : 'Inside the formula';
    if (intro) {
      intro.textContent = hasRoutine
        ? 'Discover the key ingredients selected for every step of your SOVAH routine.'
        : 'Discover the key ingredients selected for this SOVAH formula.';
    }
    if (openLabel) openLabel.textContent = 'View full INCI';
    if (dialogEyebrow) dialogEyebrow.textContent = 'SOVAH FORMULA DETAILS';
    if (dialogTitle) dialogTitle.textContent = 'Full INCI list';
    if (dialogIntro) {
      dialogIntro.textContent = hasRoutine
        ? 'Complete ingredient information for every formula in this routine.'
        : 'Complete ingredient information for this formula.';
    }
  };

  const ingredientAccordion = () =>
    [...document.querySelectorAll('main details[data-testid="accordion-details"]')].find((details) =>
      LABELS.has(normalize(details.querySelector('summary')?.textContent)),
    );

  const productSection = (main) => {
    const product = main.querySelector(
      'product-information,[data-testid="product-information"],.product-information,[data-product-information]',
    );
    return product?.closest('.shopify-section') || main.querySelector('.shopify-section') || main.firstElementChild;
  };

  const placeRoot = (root) => {
    const main = document.querySelector('main');
    if (!main || !root) return;

    const accordion = ingredientAccordion();
    if (accordion) {
      accordion.hidden = true;
      accordion.dataset.sovahIngredientsReplaced = 'true';
    }

    const section = productSection(main);
    if (section?.parentElement) {
      if (section.nextElementSibling !== root) section.insertAdjacentElement('afterend', root);
    } else if (root.parentElement !== main) {
      main.appendChild(root);
    }

    root.hidden = false;
    root.dataset.sovahIngredientsReady = 'true';
  };

  const activateTab = (tab, focus = false) => {
    const root = tab.closest(ROOT);
    if (!root) return;
    const tabs = [...root.querySelectorAll('[data-sovah-ingredients-tab]')];
    const panels = [...root.querySelectorAll('[data-sovah-ingredients-panel]')];

    tabs.forEach((item) => {
      const active = item === tab;
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
    });
    panels.forEach((panel) => {
      panel.hidden = panel.id !== tab.getAttribute('aria-controls');
    });
    if (focus) tab.focus();
  };

  const openDialog = (trigger) => {
    const dialog = trigger.closest(ROOT)?.querySelector('[data-sovah-ingredients-dialog]');
    if (!dialog) return;

    lastTrigger = trigger;
    trigger.setAttribute('aria-expanded', 'true');
    try {
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else dialog.setAttribute('open', '');
    } catch (_error) {
      dialog.setAttribute('open', '');
    }

    dialog.classList.add('is-open');
    document.documentElement.classList.add('sovah-ingredients-lock');
    requestAnimationFrame(() => dialog.querySelector('[data-sovah-ingredients-close]')?.focus());
  };

  const closeDialog = (dialog) => {
    if (!dialog) return;
    try {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
    } catch (_error) {
      dialog.removeAttribute('open');
    }

    dialog.classList.remove('is-open');
    document.documentElement.classList.remove('sovah-ingredients-lock');
    if (lastTrigger) {
      lastTrigger.setAttribute('aria-expanded', 'false');
      lastTrigger.focus({ preventScroll: true });
    }
    lastTrigger = null;
  };

  const bind = (root) => {
    root.querySelectorAll('[data-sovah-ingredients-open]').forEach((button) => {
      if (button.dataset.sovahOpenBound === 'true') return;
      button.dataset.sovahOpenBound = 'true';
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        openDialog(button);
      });
    });

    if (root.dataset.sovahBound === 'true') return;
    root.dataset.sovahBound = 'true';

    root.addEventListener('click', (event) => {
      const close = event.target.closest('[data-sovah-ingredients-close]');
      if (close) {
        event.preventDefault();
        closeDialog(close.closest('dialog'));
        return;
      }
      const tab = event.target.closest('[data-sovah-ingredients-tab]');
      if (tab) {
        event.preventDefault();
        activateTab(tab);
      }
    });

    root.addEventListener('keydown', (event) => {
      const tab = event.target.closest('[data-sovah-ingredients-tab]');
      const list = tab?.closest('[role="tablist"]');
      if (!tab || !list) return;
      const tabs = [...list.querySelectorAll('[data-sovah-ingredients-tab]')];
      const current = tabs.indexOf(tab);
      let next = null;
      if (event.key === 'ArrowRight') next = (current + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next === null) return;
      event.preventDefault();
      activateTab(tabs[next], true);
    });

    const dialog = root.querySelector('[data-sovah-ingredients-dialog]');
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog(dialog);
    });
    dialog?.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog(dialog);
    });
    dialog?.addEventListener('close', () => {
      dialog.classList.remove('is-open');
      document.documentElement.classList.remove('sovah-ingredients-lock');
    });
  };

  const init = () => {
    injectStyles();
    document.querySelectorAll(ROOT).forEach((root) => {
      applyBrandCopy(root);
      bind(root);
      placeRoot(root);
    });
    document.querySelectorAll('details[data-sovah-ingredients-replaced="true"]').forEach((details) => {
      details.hidden = true;
    });
  };

  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(init, 120);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
